import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { createNotification } from "./Popup";
import { getStageID } from "../utility/Common";

const CentryReusableComponent = ({ applicationManagement }) => {
  const navigate = useNavigate();

  const checkApplicationStage = useCallback((flowType) => {
    const stID = +getStageID();
    if (stID) {
      const redirectStages = [
        140, 130, 150, 160, 300, 500, 510, 520, 530, 540, 550, 600, 610, 620,
        1000,
      ];

      if (flowType == 1 && stID > 120) {
        navigate("/stp10");
        createNotification({ type: "error", message: "Access denied" })();
      } else if (flowType == 2 && redirectStages.includes(stID)) {
        navigate("/stp10");
        createNotification({ type: "error", message: "Access denied" })();
      }
    } else {
      navigate("/continue");
      //   navigate("/upload-photo");
    }
  }, []);

  return { checkApplicationStage };
};

CentryReusableComponent.propTypes = {
  applicationManagement: PropTypes.func, // Adjust the type based on actual usage
};

export default CentryReusableComponent;
